export default __webpack_public_path__ + "static/RTG_PDP_LOGO_MOLECULE_805x100-f0e431edb96ef21118578926c2329ad1.png";